import { doc, getDoc, onSnapshot, collection } from "firebase/firestore";
import { db } from "@/fb";
import { config } from "@/utils/configuration/config";

export default class ShipTypeRepoFirebase {
  constructor() {
    //console.log("Construyendo ShipTypeRepoFirebase");
  }

  async getShipType(ref, ship, callback) {
    const docRef = doc(db, config.firebaseConfig.shipTypesCollectionName, ref);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      const typeReceived = {
        id: ref,
        ...data,
      };
      callback(ref, ship, typeReceived);
    } else {
      // doc.data() will be undefined in this case
      //console.log("ShipTypeRepoFirebase - No such document!");
    }
  }
  async getTypes(types, service) {
    //console.log("ShipTypeRepoFirebase-getTypes");
    onSnapshot(collection(db, config.firebaseConfig.shipTypesCollectionName), (querySnapshot) => {
      const changes = querySnapshot.docChanges();

      changes.forEach(async (change) => {
        if (change.type === "added") {
          service(types, {
            id: change.doc.id,
            ...change.doc.data(),
          });
        }
      });
    });
  }
}
